/* global $ */


  $(function () {

    //flush header to top of page with transparent bg
    if ($('#site-header').attr('data-flush-header') == 'true') {
    $('#PageContainer').addClass('flush--enabled');
  }
  else {
      $('#PageContainer').addClass('flush--disabled');


  }
    //enable bar
    //true/keep on scroll
    //site content flush to top
    if ( ($("#annoucement__bar").hasClass("annoucement__bar--true scroll--true"))
    && ($('#site-header').attr('data-flush-header') == 'true')  ) {
          $("#PageContainer").addClass('ac');
}
//enable bar
//hide bar on scroll
//site content flush to top

          if ( ($("#annoucement__bar").hasClass("annoucement__bar--true scroll--false"))
          && ($('#site-header').attr('data-flush-header') == 'true')  ) {
                $("#PageContainer").addClass('ac');

              }

              //enable bar
              //true bar on scroll
              //site content NOT flush to top


                if ( ($("#annoucement__bar").hasClass("annoucement__bar--true scroll--true"))
                && ($('#site-header').attr('data-flush-header') == 'false')  ) {
                      $("#PageContainer").addClass('ar');
                      $(".header__container").addClass('solid');
            }

            //enable bar
            //hide bar on scroll
            //site content not flush to top

            if ( ($("#annoucement__bar").hasClass("annoucement__bar--true scroll--false"))
            && ($('#site-header').attr('data-flush-header') == 'false')  ) {
                  $("#PageContainer").addClass('ar');
                  $(".header__container").addClass('solid');
        }
        //disable bar
        //
        //site content flush to top

            if ( ($("#annoucement__bar").hasClass("annoucement__bar--false"))
            && ($('#site-header').attr('data-flush-header') == 'true')  ) {
                  $("#PageContainer").addClass('pp');
        }

        //disable bar
        //
        //site content NOT flush to top

        if ( ($("#annoucement__bar").hasClass("annoucement__bar--false"))
        && ($('#site-header').attr('data-flush-header') == 'false')  ) {
              $("#PageContainer").addClass('ad');
                  $(".header__container").addClass('solid');
    }


});


//Change HEADER on scroll down
$(function() {
  var header = $("#site-header");

  $(window).scroll(function() {
    var scroll = $(window).scrollTop();

    if (scroll >= 40) {
      header.removeClass('defaultHeader').addClass("scrolledHeader");


    } else {
      header.removeClass("scrolledHeader").addClass('defaultHeader');

    }
  });
});

//mobile menu - slide out

$('.moveup').click(function() {
  $('.mobile-nav').addClass('menu-mobile-animate');
});

$('.moveout').click(function() {
  $('.mobile-nav').removeClass('menu-mobile-animate');
});


// add to cart from home and collection pages
function AddToBagGrid($id) {
  var quantity = '1';//add quantity selector here
  var id= $id;// variant selector here
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: {id:id,quantity:quantity},
    success: function(){
      $(".js-drawer-open-button-right").trigger("click");
    }
  });
};

//faqs accordian
//faqs accordion
if (jQuery(".toggle .toggle-title").hasClass('active')) {
  jQuery(".toggle .toggle-title.active").closest('.toggle').find('.toggle-inner').show();
}
jQuery(".toggle .toggle-title").click(function () {
  if (jQuery(this).hasClass('active')) {
    jQuery(this).removeClass("active").closest('.toggle').find('.toggle-inner').slideUp(200);
  }
  else {
    jQuery(this).addClass("active").closest('.toggle').find('.toggle-inner').slideDown(200);
  }
});


//facebook pixel

// giveaway page
if ($('[data-section-type="giveaway-content-section"]').length > 0) {
  let $parent = $('[data-section-type="giveaway-content-section"]');
  $('#confirm_giveaway [data-action="submit-form"]').on('click', function(e) {
    e.preventDefault();
    // window.Shopify.recaptchaV3.addToken(this, "confirm_giveaway"); 
    $($parent).find('[data-action="loadding"]').removeClass('hide');
    let self = $parent;
    setTimeout(function(){
      $($parent).find('[data-action="loadding"]').addClass('hide');
      let nameField = $(self).find('#submitName');
      let emailField = $(self).find('#submitEmail');
      let confirmField = $(self).find('#submitConfirm');
      let result = true;

      if (nameField.val() === '') {
        result = false;
        $(nameField).addClass('error');
        $(nameField).siblings('.validate-name').removeClass('hide');
      } else {
        $(nameField).removeClass('error');
        $(nameField).siblings('.validate-name').addClass('hide');
      }

      if (emailField.val() === '') {
        result = false;
        $(emailField).addClass('error');
        $(emailField).siblings('.validate-email-empty').removeClass('hide');
      } else if (!validateEmail(emailField.val())) {
        result = false;
        $(emailField).addClass('error');
        $(emailField).siblings('.validate-email-empty').addClass('hide');
        $(emailField).siblings('.validate-email').removeClass('hide');
      } else {
        $(emailField).removeClass('error');
        $(emailField).siblings('.validate-email-empty').addClass('hide');
        $(emailField).siblings('.validate-email').addClass('hide');
      }

      if (!confirmField.is(':checked')) {
        result = false;
        $(confirmField).addClass('error');
        $(confirmField).siblings('.validate-confirm').removeClass('hide');
      } else {
        $(confirmField).removeClass('error');
        $(confirmField).siblings('.validate-confirm').addClass('hide');
      }

      if (!result) {
        $('.submit-error').removeClass('hide');
      } else {
        $parent.find('#confirm_giveaway').submit();
      }
    }, 1500);
  });
}

function validateEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}